import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import { HammerIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Paragraph, QuillText, tokens } from '@treams/treams-ui';

import PopoverTarget from '../../popovers/PopoverTarget';

const Container = styled(Box)<{ unspaced?: boolean }>`
	background: ${(props) => (props.unspaced ? 'white' : tokens.surface.primary)};
	border-radius: 4px;
	border: 1px solid ${tokens.border.subtle};
	border-radius: 4px;
	box-shadow: 0 2px 4px ${rgba(tokens.border.subtle, 0.5)};
`;

const TooltipTitle = styled.div`
	border-top: 1px solid ${tokens.border.subtle};
	padding-top: 10px;
	margin: 0px -20px;
	margin-top: 10px !important;
	margin-bottom: -5px;
	text-align: center;
`;

export default function GoalListItemCompetency(props: {
	competency: graphql.CompetencyGoal;
	unspaced?: boolean;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const option = props.competency.competency.levels[props.competency.competencyLevelIndex];

	return (
		<Container unspaced={props.unspaced} p={3}>
			<Box mb={2}>
				<Paragraph color="slateBlue">{t('goals.list.attachedCompetency')}</Paragraph>
			</Box>
			<Flex justifyContent="space-between">
				<Box fontWeight="bold">
					<Paragraph color="antracite">
						{localize(props.competency.competency.title).text}
					</Paragraph>
				</Box>
				<PopoverTarget
					content={
						<Box style={{ padding: 20 }}>
							<Paragraph>
								<QuillText
									value={localize(option.criteria ?? [])?.text}
									placeholder={t('evaluation.submission.competency.levels.noDescription')}
								/>
							</Paragraph>
							<TooltipTitle>{localize(option.level.title).text}</TooltipTitle>
						</Box>
					}
				>
					<Flex alignItems="center">
						<Box flexGrow={0} flexShrink={0} mr={1} size={16}>
							<HammerIcon />
						</Box>
						<Box flexGrow={0} flexShrink={0}>
							<Paragraph color="antracite">{localize(option.level.title).text}</Paragraph>
						</Box>
					</Flex>
				</PopoverTarget>
			</Flex>
		</Container>
	);
}
